
import * as types from "./types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";

import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { licenceAccountsService } from "../../services/licence-accounts.service";
import router from '../../../../router';
//import { invoiceListLDTRoutes } from "../../../accounting/router/routes";

const NavTabModule = getNavTabModule(types.LicenceAccountsDetails, 'licenceAccountsDetails');
export const licenceAccountsActions = {
  
  async [types.LicenceAccountsList.INSERT.SINGLE]({commit,getters,dispatch},payload){
    const  {licence_account_name , keyword , label_status_id} =payload;

    const res = await licenceAccountsService.newLicenceAccount(licence_account_name,keyword,label_status_id); 
    console.log("RES",res);
    if(res.data.licence_account_id){
      
      const newList=await licenceAccountsService.loadLicenceAccounts();

      console.log("newList:::",newList)

      commit(types.LicenceAccountsList.SET.ALL, {
        ...getters.licenceAccountsList,
        licence_accounts: newList.data.licence_accounts
        
      });

      //redirect logic
      return res.data.licence_account_id;

    }

  },


  async [types.LicenceAccountsList.UPDATE.SINGLE]({commit, getters, dispatch },payload){
    const { kVal,name,value } = payload
    const key="licence_account_id"

    if(name==="status"){

      const { itemID,colorPropertyName,colorPropertyValue,colorName,colorValue } = value;

      commit(types.LicenceAccountsList.SET.ALL, {
        ...getters.licenceAccountsList,
        licence_accounts: getters.licenceAccountsList.licence_accounts.map(e => {
          if (e.licence_account_id == itemID) {
            return {
              ...e,
              [colorName]: colorValue,
              [colorPropertyName]: colorPropertyValue
            }
          }
  
          return { ...e }
        }),
  
      });
  
      await MHTTPCL.modify(key,itemID,'label_status_id',colorPropertyValue,"l_licence_accounts");
      //await MHTTPCL.modify(key,itemID,colorName,colorValue,"l_licence_accounts");
    }else{
      commit(types.LicenceAccountsList.UPDATE.SINGLE,payload)
      await MHTTPCL.modify(key,kVal,name,value,"l_licence_accounts");
    }

    

  },

  async [types.LicenceAccountsList.DELETE.SINGLE]({commit, getters, dispatch },payload){
    const {licence_account_id} = payload


    commit(types.LicenceAccountsList.DELETE.SINGLE,payload)
    await licenceAccountsService.removeLicenceAccount(licence_account_id);

  },

  async [types.LicenceAccountsList.SET.ALL]({commit, getters, dispatch },payload){
    
    console.log("PPPPPPPP",payload)

    commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
      ...getters.licenceAccountsList,
      licence_account_statuses:[...payload]
    });
   

  },
  
  async [types.LicenceAccountsList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


    let res;
    console.log("PAYLOAD",payload);
    
    if (searchMode == 'none') {
      if (start == 0) {
        res = await HttpClient.mergeRequests([
          licenceAccountsService.getLicence(),
          licenceAccountsService.licenceAccountList(),  
        ]);

        console.log("RES",res)

        commit(types.LicenceAccountsList.SET.ALL,  {
          ...getters.licenceAccountsList,
          ...res,
          
        } );  // <-- Directly Set the Data. Depends on your particular Logic
      } else {                // <-- Pagination Logic
        res = await licenceAccountsService.licenceAccountList(start,row_count);            // <-- Pagination Logic
        
        console.log("res",res)
      
        commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.licenceAccountsList,
          licence_accounts: [
            ...getters.licenceAccountsList.licence_accounts,
            ...res.data.licence_accounts, // <-- append new Fetched List
          ]
        });

        // Setting EOL
        // if (!(res?.data?.length <= 0)) {
        //   return EOL_REACHED;
        // }
      }

    }else if (searchMode == 'basic') {
       const {   searchString  } = basicFilter;
       
        res = await licenceAccountsService.licenceAccountList(start,row_count,searchString);
       //res = await licenceAccountsService.searchLcncAccs(licence_statuses,searchString);
       console.log("Basic Search Res",res)
      if (start == 0) {
        commit(types.LicenceAccountsList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.licenceAccountsList,
          licence_accounts: res.data.licence_accounts
        });
      } 
      else {                // <-- Pagination Logic
        commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.licenceAccountsList,
          licence_accounts: [
            ...getters.licenceAccountsList.licence_accounts,
            ...res.data.licence_accounts, // <-- append new Fetched List
          ]
        });
      }
      // Setting EOL
      // if (!(res?.data?.length > 0)) {
      //   return EOL_REACHED;
      // }
    } else if (searchMode == 'advanced') {
      // console.log({ "searchFilter": searchFilter });
      const { licence_account_status,licence_status ,due ,active,search} =searchFilter;
      const {   searchString  } = basicFilter;
      res = await licenceAccountsService.licenceAccountList(start,row_count,search,licence_status,licence_account_status,due,active);
      console.log("DATA",payload);
      if (start == 0) {
        commit(types.LicenceAccountsList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.licenceAccountsList,
          licence_accounts: res.data.licence_accounts
        });
      } else {
        commit(types.LicenceAccountsList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.licenceAccountsList,
          licence_accounts: [
            ...getters.licenceAccountsList.licence_accounts,
            ...res.data.licence_accounts, // <-- append new Fetched List
          ]
        });
      }
      // Setting EOL
      // if (!(res?.data?.length > 0)) {
      //   return EOL_REACHED;
      // }
    }

      //const statementOverviewData = await HttpClient.mergeRequests(promises);
    
    //console.log("StatementOverviewData",statementOverviewData);

     //commit(types.BelieveStatementList.SET.ALL,  statementOverviewData );
  },


  async [types.LicenceAccountsDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    
    
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { flag, licence_account, reload } = payload;

    console.log("::::::::::::::::::::::::::::::::::::::::::::::",payload);

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'licence_account_id';
    const itemName = 'licence_account';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'licenceAccountsDetails';
    const DetailsAction = types.LicenceAccountsDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req

    const detailsResponse = await HttpClient.mergeRequests([
      licenceAccountsService.licenceAccountDetails(licence_account.licence_account_id),
      licenceAccountsService.lcncAccDetailsTabOverview(licence_account.licence_account_id),
     // licenceAccountsService.lcncAccDetailsTabLicences(licence_account.licence_account_id),
      licenceAccountsService.licenceAccountRelatedLicences(licence_account.licence_account_id),
      licenceAccountsService.lcncAccDetailsTabInvoices(licence_account.licence_account_id)
    ]);

    console.log("DETaIlS OF RESponSE", detailsResponse);


    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, licenceAccount) => {
      return {
        ...licenceAccount,
        ...detailsResponse,
        loading: false,
      }
    })
  },

  // Left NavItem child details
  ...NavTabModule.implementActions(
    "licence_account_id",
    "licence_accounts/licence_account_id/tab",
    "licence_accounts",
    () => router,
    "licencing",
    (value, key) => {
      console.log("KEY::" ,key ,"VALUE::" ,value)

      return {
        title:
          value && value.licence_account && value.licence_account.licence_account_name
            ? value.licence_account.licence_account_name
            : key,
        full_title:
          value && value.licence_account && value.licence_account.licence_account_name
            ? value.licence_account.licence_account_name
            : key
      };
    }
  ),


  
  async [types.LicenceAccountsDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item } = payload
    const { licence_account } = item;
    const { licence_account_id } = licence_account;


    console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(licence_account_id, (licenceAccount) => {
      return {
        licence_account: {
          ...licenceAccount.licence_account,
          [name]: value,
        }
      }
    });
    const modifiedRelease = await MHTTPCL.modifyJSON('licence_account_id', licence_account_id, name, value, 'l_licence_accounts')






  },

  async [types.LicenceAccountRelatedContacts.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, licence_account } = payload;
    const { licence_account_id } = licence_account;

    const key = 'contact_relation_id';
    const kVal = item[key];
    const table = 'contact_relations';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(licence_account_id, (selectedLicenceAccountDetails) => {
      return {
        contact_relations: selectedLicenceAccountDetails.contact_relations.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(key, kVal, name, value, table)

  },

  async [types.LicenceAccountRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { contact, licence_account } = payload;
    const { licence_account_id } = licence_account;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {

        contact_relations: selectedLicenceAccountDetails.contact_relations.
          filter(e => e.contact_relation_id != contact_relation_id)
      }
    });

    const deletedContact = await licenceAccountsService.deleteContactRelation(contact_relation_id);


  },


  async [types.LicenceAccountRelatedContacts.SET.ALL]({ commit, getters, dispatch }, {
    contact_relations,
    external_table,
    external_id,
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedLicenceAccountDetails) => {
      return {
        ...selectedLicenceAccountDetails,
        contact_relations: contact_relations
      };
    })
  },

  async [types.LicenceAccountInvoices.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { licence_lines, licence_account_id,invoice_project_id } = payload;
  

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {
        ...selectedLicenceAccountDetails,
        licence_lines: selectedLicenceAccountDetails.licence_lines.
          filter(e => {
                       
                        return !licence_lines.includes(e.licence_line_id)
                 })
      }
    });


  },

  async [types.LicenceAccountInvoices.SET.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { licence_account_id } = payload
   // const { licence_lines, licence_account_id,invoice_project_id } = payload;

   const resData = await licenceAccountsService.lcncAccDetailsTabInvoices(licence_account_id);

   console.log("TTTT:::", resData)

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {
        ...selectedLicenceAccountDetails,
        licence_lines: resData.data.licence_lines
      }
    });


  },

  async [types.LicenceAccountInvoices.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { licence_account_id ,licence_lines,licence_line_id } = payload
   // const { licence_lines, licence_account_id,invoice_project_id } = payload;
  

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {
        ...selectedLicenceAccountDetails,
        licence_lines: selectedLicenceAccountDetails.licence_lines.
            filter(e => e.licence_line_id != licence_line_id)
      }
    });


  },

  async [types.LicenceInvoiceContact.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload",payload)

    const { external_id ,item_contact } =payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedLicenceAccountDetails) => {
      return {
        ...selectedLicenceAccountDetails,
        invoice_contact: item_contact
      };
    })
  },

  async [types.AccountRelatedLicence.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { licence_account_id , licenceList } = payload;

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {

        licences: [...selectedLicenceAccountDetails.licences,...licenceList]
      }
    });
  },


  async [types.AccountRelatedLicence.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { licence_account_id , licence_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {

        licences: selectedLicenceAccountDetails.licences.filter(e => e.licence_id != licence_id)
      }
    });

    const deletedContact = await licenceAccountsService.removeRelatedLicence(licence_id,licence_account_id);


  },
  async [types.AccountRelatedLicence.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const {value ,item} =payload;
    const { licence_account_id , licence_id } = item;

    NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
      return {

        licences: selectedLicenceAccountDetails.licences.map(e => {
            if(e.licence_id==licence_id){
              return {
                ...e,
                active_flag:value
              }
            }else{
              return e;
            }

            
              
          })
      }
    });

    const deletedContact = await MHTTPCL.modifyJSON('licence_id',licence_id,'active_flag',value,'l_licences');


  },

  async [types.AccountRelatedLicence.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
      const NavTabHelper = NavTabModule.Helper(dispatch, getters);
      console.log("TTTT", payload)
      
      const {  licence_account_id,licence_id ,duplicate,licence_name,item} = payload;

      //const {licence_account_id}=item;

      const resLicenceList=duplicate? await licenceAccountsService.duplicateLicense(licence_id,licence_name):await licenceAccountsService.addRelatedLicence({...payload})

      //const licenceList=duplicate?licenceList.data.license:

      console.log("payload",resLicenceList);
      
      // let licenceList=[];

      // if(duplicate){
      //   licenceList=[resLicenceList.data.license]
      // }else{
      //   const newListRes= await licenceAccountsService.loadRelatedLlicences(licence_account_id);
      //   licenceList=newListRes.data.related_licences
      // }

      // console.log("licenceList",licenceList);

      if (duplicate) {
        NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
          return {  
            related_licences: [...selectedLicenceAccountDetails.related_licences,resLicenceList.data.license],
          }
        });
      } else {
        const newListRes= await licenceAccountsService.loadRelatedLlicences(licence_account_id);
        NavTabHelper.updateSingleNavTabDetails(licence_account_id, selectedLicenceAccountDetails => {
          return {  
            related_licences: newListRes.data.related_licences
          }
        });
      }

    const new_licence_id=duplicate?resLicenceList.data.license.licence_id:resLicenceList.data.licence_id;
    return new_licence_id;
  },

  

 
}
